import { getColumns } from './schema';
import { TableCell } from './TableCell';
import { TableLabel } from './TableLabel';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
/**
 * @component TableFooters
 * @since 1.0.0
 * @hidden
 */
export function TableFooters(props) {
    const { schema } = props;
    const columns = getColumns(schema);
    return (React.createElement(Fragment, null, columns.map((column) => {
        var _a;
        return (React.createElement(TableCell, { key: column, style: column, column: (_a = schema[column]) !== null && _a !== void 0 ? _a : undefined },
            React.createElement(TableLabel, { title: schema[column].header, field: column })));
    })));
}
